import { render, staticRenderFns } from "./AccountBalance.vue?vue&type=template&id=b1343838&scoped=true&"
import script from "./AccountBalance.vue?vue&type=script&lang=ts&"
export * from "./AccountBalance.vue?vue&type=script&lang=ts&"
import style0 from "./AccountBalance.vue?vue&type=style&index=0&id=b1343838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1343838",
  null
  
)

export default component.exports